import { Reducer } from "react";

import { TimeValidationError } from "@/data/time-reports";

export type TimeReportCalendarItemCellStatus = "idle" | "focus" | "blur";

export interface TimeReportCalendarItemCellState {
  value: string;
  status: TimeReportCalendarItemCellStatus;
  isValid: boolean;
  validationError?: TimeValidationError;
}

export type TimeReportCalendarItemCellAction =
  | { type: "SET_VALUE"; value: string }
  | { type: "SET_STATUS"; status: TimeReportCalendarItemCellStatus }
  | { type: "SET_IS_VALID"; isValid: boolean; error?: TimeValidationError };

export const timeReportCalendarItemCellInitialState: TimeReportCalendarItemCellState = {
  value: "",
  status: "idle",
  isValid: true,
};

export const timeReportCalendarItemCellReducer: Reducer<
  TimeReportCalendarItemCellState,
  TimeReportCalendarItemCellAction
> = (state, action) => {
  switch (action.type) {
    case "SET_VALUE": {
      return {
        ...state,
        value: action.value,
      };
    }

    case "SET_STATUS": {
      return {
        ...state,
        status: action.status,
      };
    }

    case "SET_IS_VALID": {
      return {
        ...state,
        isValid: action.isValid,
        validationError: action.error,
      };
    }

    default:
      return { ...state };
  }
};
